import React from 'react';
import PropTypes from 'prop-types';

import { LinearProgress as MUILinearProgress } from '@material-ui/core';

export const LinearProgress = props => <MUILinearProgress {...props} />;

LinearProgress.propTypes = {
  classes: PropTypes.object,
  color: PropTypes.oneOf(['primary', 'secondary']),
  value: PropTypes.number,
  valueBuffer: PropTypes.number,
  variant: PropTypes.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
};

export default LinearProgress;
